module.exports = __webpack_public_path__ + "img/close.f1101af6.svg";